import { useEffect, useRef } from 'react'
import { gsap } from 'gsap'
import Icons from './Icons'

const features = [
  {
    icon: Icons.Chart,
    title: '专业交易',
    description: '支持现货、合约、期权等多种交易模式，提供深度流动性与极速撮合引擎，满足专业交易者需求。',
    highlights: ['极速撮合', '深度流动性', '零滑点'],
  },
  {
    icon: Icons.Security,
    title: '安全防护',
    description: '军工级安全架构，采用多重签名、冷热钱包分离、实时风控等技术，全方位保障用户资产安全。',
    highlights: ['冷钱包存储', '多重签名', '实时风控'],
  },
  {
    icon: Icons.Lightning,
    title: '闪电出入金',
    description: '支持多种支付方式，法币与数字资产快速兑换，让资金流转更加高效便捷。',
    highlights: ['多通道支付', '极速到账', '低手续费'],
  },
  {
    icon: Icons.Globe,
    title: '全球化服务',
    description: '覆盖180+国家和地区，支持多语言、多币种，7x24小时客服在线，随时随地为您服务。',
    highlights: ['180+国家', '多语言支持', '24/7服务'],
  },
]

export function FeatureDeepDive() {
  const featuresRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        '.feature-card',
        { opacity: 0, y: 30 },
        {
          opacity: 1,
          y: 0,
          duration: 0.6,
          stagger: 0.15,
          scrollTrigger: {
            trigger: featuresRef.current,
            start: 'top 80%',
          },
        }
      )
    }, featuresRef)

    return () => ctx.revert()
  }, [])

  return (
    <section
      ref={featuresRef}
      id="features"
      className="section-padding relative overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0 bg-[#0a0a0f]" />
      <div className="absolute inset-0 grid-pattern opacity-20" />

      <div className="relative z-10 max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            <span className="gradient-text">交易与安全并重</span>
          </h2>
          <p className="text-[#8080a0] text-lg max-w-2xl mx-auto">
            okb官网提供全方位的数字资产服务，在保障安全的前提下，让您享受极致的交易体验
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="feature-card cyber-card group"
            >
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 rounded-2xl bg-[rgba(255,0,255,0.1)] flex items-center justify-center shrink-0 group-hover:bg-[rgba(0,255,255,0.1)] transition-colors">
                  <div className="text-[#ff00ff] group-hover:text-[#00ffff] transition-colors">
                    <feature.icon />
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-semibold text-[#e0e0ff] mb-2">
                    {feature.title}
                  </h3>
                  <p className="text-[#8080a0] mb-4 leading-relaxed">
                    {feature.description}
                  </p>
                  <div className="flex flex-wrap gap-2">
                    {feature.highlights.map((highlight, i) => (
                      <span
                        key={i}
                        className="px-3 py-1 rounded-full bg-[rgba(255,0,255,0.1)] border border-[rgba(255,0,255,0.2)] text-xs text-[#e0e0ff]"
                      >
                        {highlight}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-12 text-center">
          <a
            href="https://www.jsqkmfytwpn.com/join/1p9999"
            target="_blank"
            rel="noopener"
            className="btn-primary inline-flex items-center gap-2"
          >
            开始交易
            <Icons.ArrowRight />
          </a>
        </div>
      </div>
    </section>
  )
}
